import React, { useState, KeyboardEvent, ChangeEvent } from "react";
import { TextField, Chip } from "@mui/material";
import { Box } from "@financeable-com-au/financeable-ui";

interface EmailChipsInputProps {
  emails: string[];
  setEmails: (emails: string[]) => void;
}

const EmailChipsInput: React.FC<EmailChipsInputProps> = ({ emails, setEmails }) => {
  const [input, setInput] = useState<string>("");

  const isValidEmail = (email: string): boolean => {
    // Basic email validation
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>): void => {
    if ((e.key === "Enter" || e.key === ",") && input.trim()) {
      e.preventDefault();
      addEmail(input.trim());
    }
  };

  const handleChange = (e: ChangeEvent<HTMLInputElement>): void => {
    setInput(e.target.value);
  };

  const addEmail = (email: string): void => {
    if (isValidEmail(email) && !emails.includes(email)) {
      setEmails([...emails, email]);
      setInput("");
    }
  };

  const removeEmail = (emailToRemove: string): void => {
    setEmails(emails.filter((email) => email !== emailToRemove));
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        gap: 1,
        p: 1.5,
        border: "0.1px solid",
        borderColor: "grey.300",
        borderRadius: 10,
        minHeight: 40,
        alignItems: "center",
      }}
    >
      {emails.map((email) => (
        <Chip key={email} label={email} onDelete={() => removeEmail(email)} color="primary" variant="outlined" />
      ))}
      <TextField
        variant="standard"
        value={input}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        placeholder="Enter email and press Enter"
        InputProps={{ disableUnderline: true }}
        sx={{ minWidth: 200, flex: 1 }}
      />
    </Box>
  );
};

export default EmailChipsInput;
